import {Injectable} from '@angular/core';
import {BaseEndpointService} from '../base-endpoint-service';
import {Backend} from '@generated-backend-types';
import {ListItem} from "src/app/entities/list-item.entity";
import Process = Backend.App.Resources.Dashboard.QualityManagement.Process;
import ProcessVersion = Backend.App.Resources.Dashboard.QualityManagement.ProcessVersion;
import ProcessVersionData = Backend.App.Data.Dashboard.QualityManagement.ProcessVersionData;
import {ActivatedRouteSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class ProcessVersionService extends BaseEndpointService<ProcessVersion, ProcessVersionData> {
  public override resolve(route: ActivatedRouteSnapshot): Observable<ProcessVersion> {
    const process = route.parent?.data['process'] ?? route.data['process'];
    if (process) this.forProcess(process);
    return this.get(route.params['id']).pipe(map(r => r.data));
  }

  public forProcess(process: Process) {
    this.endpoint = `/quality-management/processes/${process.id}/versions`;
  }

  public override modelToMultiSelectItem(m: ProcessVersion): ListItem & { model: ProcessVersion; } {
    return {
      id: m.id,
      text: m.title ?? m.ext_id,
      isDisabled: false,
      model: m,
    }
  }
}
